import React from "react";
import styles from "../styles";
import git from "../assets/git.png";
import twitter from "../assets/twitter.svg";

const Footer = () => {
  return (
    <div
      className={`flex flex-col gap-4 justify-between sm:flex-row items-center ${styles.paddingY} ${styles.paddingX} text-white`}
    >
      {/* <div> */}
      <h1 className="font-bold text-[50px] text-gradient">DEE</h1>
      <div className="flex flex-row gap-4 items-center">
        <a href="https://github.com/dhrumishah" target="_blank">
          <img
            src={git}
            className=" w-[38px] h-[38px] ml-1 bg-white rounded-full transition ease-in-out hover:-translate-y-1 hover:scale-110 duration-300"
          />
        </a>
        <a href="https://twitter.com/deetwts" target="_blank">
          <button className="border-white border-[2px] rounded-full hover:bg-black w-[38px] h-[38px] items-center pl-1 transition ease-in-out hover:-translate-y-1 hover:scale-110 duration-300">
            <img src={twitter} className=" w-[20px] h-[20px] ml-1" />
          </button>
        </a>
      </div>
      <p className="text-[22px]">Made with ❤️ by Dhrumi</p>
    </div>
  );
};

export default Footer;
